// extracted by mini-css-extract-plugin
module.exports = {"npl-card":"Card_npl-card__19S2R","number":"Card_number__l3ULW","name":"Card_name__2TlY5","img-box":"Card_img-box__3TGZp"};